import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import { ApiError } from '@core/model/entity/api-error.model';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  private formatErrors(error: HttpErrorResponse) {
    if (error instanceof HttpErrorResponse && error.status === 404) {
      return of(null);
    }

    const finalError = error.error ? error.error : error;
    const apiError = new ApiError(error.status, finalError.code, finalError.message);
    return throwError(() => apiError);
  }

  get<T>(path: string, options: HttpOptions = {}): Observable<T> {
    return this.http
      .request('GET', `${environment.api.baseUrl}${path}`, options)
      .pipe(catchError(this.formatErrors)) as Observable<T>;
  }

  put<T>(path: string, body: unknown = {}, options: HttpOptions = {}): Observable<T> {
    return this.http
      .request('PUT', `${environment.api.baseUrl}${path}`, { ...options, body })
      .pipe(catchError(this.formatErrors)) as Observable<T>;
  }

  post<T>(path: string, body: unknown = {}, options: HttpOptions = {}): Observable<T> {
    return this.http
      .request('POST', `${environment.api.baseUrl}${path}`, { ...options, body })
      .pipe(catchError(this.formatErrors)) as Observable<T>;
  }

  delete<T>(path: string, options: HttpOptions = {}): Observable<T> {
    return this.http
      .request('DELETE', `${environment.api.baseUrl}${path}`, options)
      .pipe(catchError(this.formatErrors)) as Observable<T>;
  }
}

export type HttpResponseType = 'arraybuffer' | 'blob' | 'json' | 'text';

export interface HttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]: string | string[];
      };
  reportProgress?: boolean;
  responseType?: HttpResponseType;
  withCredentials?: boolean;
}
